export const appConfig = {
   app: {
      versionSoft: '2018.4.15',
      errMsgDurationToShow: 5000,            // milliseconds
      successMsgDurationToShow: 3000,
      errMsgLogToConsole: true,
      showCreateDefaultsDialog: false
   },
   dev: {
      debugMode: true,                       // wird in main.ts auf false gesetzt
      mockingMode: true,                     // wird in main.ts aut false gesetzt
      mockingDataFolder: 'assets/mockdata',
      durationDelayForMockedData: 500
   },
   test: {
      showTestCredentials: false,
      account: 'test01',
      passwort: 'test01'
   },
   store: {
      storePessimisticUpdate: false
   }

};



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/config/app-config.ts